var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19967 17.7524L1.54302 24.3566L5.64495 23.5895M10.4653 20.9545L8.0259 27L5.63659 23.5978M17.792 17.7524L20.4486 24.3566L16.3467 23.5895L13.9574 26.9917L11.518 20.9378M10.9916 6.38679L12.5038 9.69724L16.0794 10.1309L13.4311 12.6074L14.1328 16.1847L10.9916 14.4086L7.85046 16.1847L8.55221 12.6074L5.90393 10.1309L9.47953 9.69724L10.9916 6.38679ZM9.09524 2.9179L6.5472 2.00898L5.67001 4.56062L2.97995 4.84413L3.29741 7.52919L1 8.9551L2.45363 11.2316L1 13.508L3.29741 14.9339L2.97995 17.619L5.67001 17.9025L6.5472 20.4541L9.09524 19.5452L11 21.4631L12.9048 19.5452L15.4528 20.4541L16.33 17.9025L19.0201 17.619L18.7026 14.9339L21 13.508L19.5464 11.2316L21 8.9551L18.7026 7.52919L19.0201 4.84413L16.33 4.56062L15.4528 2.00898L12.9048 2.9179L11 1L9.09524 2.9179Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlata);
export default __webpack_public_path__ + "static/media/plata.0a0a9b1e552b53eb3093e5bf4cb946aa.svg";
export { ForwardRef as ReactComponent };